"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fonts = void 0;
/** font with string type */
var Fonts;
(function (Fonts) {
    Fonts["default"] = "roundedMplus";
    Fonts["black"] = "roundedMplusBlack";
})(Fonts = exports.Fonts || (exports.Fonts = {}));
